import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
//import Components from '../components/loader'
//let _components = require('../components/loader')
import Portal from '@/views/Portal'
import Course from '@/views/Course'
import Content from '@/views/Content'
import DemoEditor from '@/views/DemoDataEditor'
import SeriesEditor from '@/views/SeriesDataEditor'
// import GoogleFont from  '@/views/GoogleFont'

// Import Vuex
import vuex from '../vuex'

Vue.use(Router)

const router = new Router({
  // mode:'history',
  vuex,
  routes: [
    {
      path: '/',
      name: 'Portal',
      component: Portal,
      meta: { needGuard: true },
    },
    // {
    //   path: '/googlefont',
    //   name: 'GoogleFont',
    //   component: GoogleFont
    // },
    {
      path: '/apply-steps',
      name: 'ApplySteps',
      component: Content,
      meta: { needGuard: true },
    },
    {
      path: '/series',
      name: '_Course',
      component: Course,
      meta: { needGuard: true },
    },
    {
      path: '/series/:series_id/:course_id',
      name: 'Course',
      component: Course,
      meta: { needGuard: true },
      beforeEnter(to, from, next) {
        console.log('beforeEnter: Course')
        next()
      },
    },
    {
      path: '/demo-editor',
      name: 'demo-editor',
      component: DemoEditor,
      meta: { needGuard: true },
    },
    {
      path: '/editor',
      name: 'editor',
      component: SeriesEditor,
      meta: { needGuard: true },
    },
  ],

  scrollBehavior(to, from, savedPosition) {
      return {
          x: 0,
          y: 0,
      };
  },

//   beforeRouteLeave(to, from, next) {
//       console.log('>>> beforeRouteLeave')
//       next(false)
//   },
})

// router.beforeEach((to, from, next) => {
//   console.log('router.beforeEach', to, from)
//   next()
// })

// router.beforeResolve((to, from, next) => {
// 	console.log('router.beforeResolve', to, from)
//   next()
// })

// function guardRoute (to, from, next) {
//     alert('guardRoute');
//     if (window.confirm(`Navigate to ${to.path}?`)) {
//         next()
//     } else if (window.confirm(`Redirect to /baz?`)) {
//         next('/baz')
//     } else {
//         next(false)
//     }
// }

// router.beforeEach((to, from, next) => {
//     if (to.matched.some(m => m.meta.needGuard)) {
//         guardRoute(to, from, next)
//     } else {
//         next()
//     }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js